import _objectSpread from "/app/src/Web/InternetBranch/node_modules/@babel/runtime-corejs2/helpers/esm/objectSpread2.js";
import Vue from 'vue';
import VueI18n from 'vue-i18n';
import Cookies from 'js-cookie';
import elementEnLocale from 'element-ui/lib/locale/lang/en';
import elementTrLocale from 'element-ui/lib/locale/lang/tr-TR';
import enLocale from "./en";
import trLocale from "./tr";
import financeTr from "./tr/finance";
import financeEn from "./en/finance";
import hrTr from "./tr/hr";
import hrEn from "./en/hr";
import bpmTr from "./tr/bpm";
import bpmEn from "./en/bpm";
import crmTr from "./tr/crm";
import crmEn from "./en/crm";
import weTr from "./tr/we";
import weEn from "./en/we";
import dmsTr from "./tr/dms";
import dmsEn from "./en/dms";
import internetBranch from "./tr/internetBranch";
Vue.use(VueI18n);
var messages = {
  en: _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, enLocale), financeEn), elementEnLocale), hrEn), bpmEn), crmEn), weEn), dmsEn),
  tr: _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, trLocale), financeTr), elementTrLocale), hrTr), bpmTr), crmTr), weTr), dmsTr), internetBranch)
};
export var numberFormats = {
  'en-US': {
    currency: {
      style: 'currency',
      currency: 'USD'
    }
  },
  'ja-JP': {
    currency: {
      style: 'currency',
      currency: 'JPY',
      currencyDisplay: 'symbol'
    }
  },
  'tr-TR': {
    currency: {
      style: 'currency',
      currency: 'TRY',
      currencyDisplay: 'symbol'
    }
  }
};
var i18n = new VueI18n({
  locale: Cookies.get('language') || 'tr',
  messages: messages,
  numberFormats: numberFormats
});
export default i18n;